import React from "react";
import logoIcon from "../assets/logoNew.png"; 
import {
  Mail,
  Phone,
  MapPin,
  Facebook,
  Twitter,
  Linkedin,
  Instagram,
  
} from "lucide-react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* ===== Footer Grid ===== */}
        <div className="footer-grid">
          {/* Brand & Social */}
          <div className="footer-col">
  <div className="footer-brand">
    <img src={logoIcon} alt="logo" className="logo-img" />
    <div className="brand-text">
      <h3 className="footer-logo">Codex Future</h3>
      <p className="footer-subtitle">IT Training & Placement</p>
    </div>
  </div>

  <p className="footer-description">
    Best IT training institute in Indore offering job-guaranteed
    courses with 100% placement assistance.
  </p>
            <div className="footer-social">
              <a href="#facebook" className="social-link " aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="#twitter" className="social-link" aria-label="Twitter">
                <Twitter size={20} />
              </a>
              <a href="https://www.linkedin.com/company/codex-future-technologies/" className="social-link" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
              <a href="https://www.instagram.com/codexfuture_official?igsh=MXBnMDZoNHo3b3V6OA==" className="social-link" aria-label="Instagram">
                <Instagram size={20} />
              </a>
               <a
                href="https://wa.me/919303715744"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link whatsapp-link"
                aria-label="WhatsApp"
               >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                >
                <path d="M12 0C5.373 0 0 5.373 0 12a11.93 11.93 0 001.64 6.02L0 24l6.24-1.64A11.93 11.93 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm6.63 17.138c-.273.772-1.604 1.462-2.206 1.555-.567.085-1.278.121-2.061-.127-.474-.15-1.085-.352-1.866-.691-3.285-1.42-5.421-4.707-5.586-4.93-.164-.224-1.332-1.77-1.332-3.376 0-1.606.842-2.397 1.14-2.724.299-.328.654-.41.872-.41.218 0 .436 0 .627.012.201.01.473-.076.74.565.273.662.93 2.288 1.01 2.455.08.168.134.362.025.586-.107.224-.163.361-.32.556-.16.196-.338.438-.483.589-.161.167-.329.35-.142.686.187.336.829 1.37 1.78 2.217 1.225 1.093 2.261 1.432 2.594 1.597.333.164.524.146.718-.088.195-.235.824-.961 1.042-1.29.218-.328.446-.274.74-.164.294.11 1.864.878 2.184 1.038.32.16.533.235.61.366.078.132.078.763-.195 1.534z" />
               </svg>
                </a>

            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-col">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#home">Home</a></li>
              <li><a href="/allcourses">Courses</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="#testimonials">Testimonials</a></li>
              <li><a href="/blogs">Blog</a></li>
            </ul>
          </div>

          {/* Popular Courses */}
          <div className="footer-col">
            <h4 className="footer-title">Popular Courses</h4>
            <ul className="footer-links">
              <li><a href="/course-mern">MERN Stack</a></li>
              <li><a href="/course-data">Data Analytics</a></li>
              <li><a href="/course-python">Python Django</a></li>
              <li><a href="/course-react">ReactJS</a></li>
              <li><a href="/course-marketing">Digital Marketing</a></li>
              <li><a href="/course-cybersecurity">Cyber Security </a></li>
              <li><a href="/course-devops">DevOps </a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-col">
            <h4 className="footer-title">Contact Info</h4>
            <ul className="footer-contact">
              <li>
                <MapPin size={18} />
                <span>Indore, Madhya Pradesh, India</span>
              </li>
              <li>
                <Phone size={18} />
                <span>+91 9303715744</span>
              </li>
              <li>
                <Mail size={18} />
                <span>info@codexfuture.in</span>
              </li>
            </ul>
          </div>
        </div>

        {/* ===== Bottom Section ===== */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2025 Codex Future. All rights reserved.
          </p>
          <div className="footer-bottom-links">
            <a href="/contact">Privacy Policy</a>
            <a href="/contact">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
